import { getUTMParams } from "./utm";

export function trackEvent(eventName, extraParams = {}) {
  try {
    const utmParams = getUTMParams() || {};

    // Google Analytics (GA4) — UTM not needed, GA4 auto-attributes
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", eventName, extraParams);
    }

    // Mixpanel — UTM needed, Mixpanel doesn't auto-capture
    if (typeof window !== "undefined" && typeof window.mixpanel === "object") {
      window.mixpanel.track(eventName, {
        ...extraParams,
        ...utmParams,
      });
    }

    // GTM dataLayer — for custom GTM triggers
    if (typeof window !== "undefined" && Array.isArray(window.dataLayer)) {
      window.dataLayer.push({ event: eventName, ...extraParams });
    }
  } catch (error) {
    console.error("Tracking error:", error);
  }
}